import lodashGet from "lodash/get";

export default {
    pageTitlePrefix: lodashGet(window, "_VIEW_CONFIG.pageTitlePrefix", "Upgrade") || "Upgrade",
};
